// desperately needs cleanup

// imports
import { gsap, ScrollTrigger } from 'gsap/all';
import Component from 'minsky-kit/js/components/Component';
import HeaderSlideOut from './HeaderSlideOut';
import Submenu from './Submenu';

// register plugins
gsap.registerPlugin(ScrollTrigger);

// private statics

// class definition
export default class Header extends Component {
    // constructor
    constructor (args = {}, objectName = 'Header') {
        args.debug = args.debug || true;

        // super
        super(args, objectName);

        // set properties
        this._isOpen = false;
        this._transparent = args.transparent || !!this._$el.closest('.page--is-front') || false;
        this._scrollTl = null;
        this._isMobile = null;
        this._submenu = null;
        this._submenuVisible = false;
        this._tl = {
            open:  null,
            close: null,
        };

        // grab some components we want to manage
        this._$logoDesktop = this.$el.querySelector('.header__logo--desktop');
        this._$hamburger = this.$el.querySelector('.header__hamburger');
        this._$headerSections = this.$el.querySelectorAll('.header__section');
        this._$langSwitchDesktop = this.$el.querySelector('.header__language-switcher');
        this._$mainMenuNav = this.$el.querySelector('.menu--main-navigation-2');
        this._$mainMenu = this.$el.querySelector('.menu--main');
        this._$deco = this.$el.querySelector('.header__deco');
        this._$decoShape = this._$deco.querySelector('.header__deco-shape');
        this._$decoFill = this._$deco.querySelector('.header__deco-fill');
        this._$locationsWrapper = this._$el.querySelector('.header__locations-wrapper');
        this._$submenuHamburger = this._$el.querySelector('.submenu__hamburger');
        this._$submenuLanguageSwitcher = this._$el.querySelector('.submenu__language--desktop');

        // init reservation slide out
        const $reservationTrigger = this._$el.querySelectorAll('.menu__item--id-89 .menu__link');
        if ($reservationTrigger) {
            this._reservationSO = new HeaderSlideOut({
                $el:       this._$locationsWrapper.querySelector('.header__locations--reservation'),
                $triggers: $reservationTrigger,
            });

            this._reservationSO.on('open', this.blm.addOnce('onListOpen', onListOpen));
            this._reservationSO.on('close', this.blm.addOnce('onListClose', onListClose));
        }

        // init take out slide out
        const $takeoutTrigger = this._$el.querySelectorAll('.menu__item--id-121 .menu__link');
        if ($takeoutTrigger) {
            this._takeoutSO = new HeaderSlideOut({
                $el:       this._$locationsWrapper.querySelector('.header__locations--takeout'),
                $triggers: $takeoutTrigger,
            });

            this._takeoutSO.on('open', this.blm.addOnce('onListOpen', onListOpen));
            this._takeoutSO.on('close', this.blm.addOnce('onListClose', onListClose));
        }

        // init delivery slide out
        // const $deliveryTrigger = this._$el.querySelectorAll('.menu__item--id-120 .menu__link');
        // if ($deliveryTrigger) {
        //     this._deliverySO = new HeaderSlideOut({
        //         $el:       this._$locationsWrapper.querySelector('.header__locations--delivery'),
        //         $triggers: $deliveryTrigger,
        //     });

        //     this._deliverySO.on('open', this.blm.addOnce('onListOpen', onListOpen));
        //     this._deliverySO.on('close', this.blm.addOnce('onListClose', onListClose));
        // }

        initSubmenu.call(this);
        initReservation.call(this);

        window.header = this;
    }

    // methods
    refresh () {
        if (this._tl.open) this._tl.open.invalidate();
        if (this._tl.close) this._tl.close.invalidate();
        if (this._scrollTl) this._scrollTl.invalidate();

        if (this._isOpen) {
            this.open(true);
        }
        else {
            this.close(true);
        }
    }

    open (force = false) {
        if (!this._isOpen || force) {
            this._isOpen = true;
            this._tl.open
                .invalidate()
                .restart();

            if (this._submenu.shown) this._submenu.hide();
        }
    }

    close (force = false) {
        if (this._isOpen || force) {
            this._isOpen = false;
            this._tl.close
                .invalidate()
                .restart();

            if (this._reservationSO.isOpen || force) this._reservationSO.close();
            if (this._takeoutSO.isOpen || force) this._takeoutSO.close();
            // if (this._deliverySO.isOpen || force) this._deliverySO.close();

            if (this._submenuVisible) this._submenu.show();
        }
    }

    // refresh () {
    //     destroyTimelines.call(this);
    //     initTimelines.call(this);
    // }

    scrollRefresh () {
        this.$el.classList.toggle('header--scrolled-enough', window.scrollY > window.innerHeight / 2);
    }

    // methods
    destroy () {
        destroyTimelines.call(this);

        super.destroy();
    }

    // getters & setters
    get mobile () {
        return this._isMobile;
    }

    set mobile (value) {
        if (this._isMobile != value) {
            this._isMobile = value;

            if (value === true) {
                destroyTimelines.call(this);
            }
            else if (value === false) {
                initTimelines.call(this);
            }

            if (this._reservationSO) this._reservationSO.mobile = value;
            if (this._takeoutSO) this._takeoutSO.mobile = value;
            // if (this._deliverySO) this._deliverySO.mobile = value;
        }
    }

    get openSlideOut () {
        if (this._reservationSO.isOpen) return this._reservationSO;
        if (this._takeoutSO.isOpen) return this._takeoutSO;
        // if (this._deliverySO.isOpen) return this._deliverySO;
        return null;
    }
}

// Utils
function initSubmenu () {
    const $submenu = document.querySelector('.header__submenu');
    if ($submenu) {
        const $trigger = $submenu.querySelector('.hamburger');
        const $el = $submenu.querySelector('.submenu');

        if ($trigger && $el) {
            this._submenu = new Submenu({
                $el,
                trigger: $trigger,
            });

            // add listener
            this._submenu.on('show', this.blm.add('onSubmenuShow', onSubmenuShow));
            this._submenu.on('hide', this.blm.add('onSubmenuHide', onSubmenuHide));
        }
    }
}

function destroySubmenu () {

}

function initTimelines () {
    // grab other components to animate inside el

    const isBigMq = window.matchMedia('(min-width: 1280px)');
    const isLargeMq = window.matchMedia('(min-width: 960px)');

    this._scrollTl = gsap.timeline({
        scrollTrigger: {
            trigger: document.body,
            start:   '0px top',
            end:     `${window.innerHeight}px top`,
            scrub:   true,
        },
        ease:       'Power0.easeNone',
        onUpdate:   this.blm.addOnce('onScrollUpdate', onScrollUpdate),
        onComplete: this.blm.addOnce('onScrollUpdate', onScrollUpdate),
    });

    // logo animation
    this._scrollTl.fromTo(this._$logoDesktop, {
        y:     0,
        scale: 1,
    }, {
        y:     -15,
        scale: 0.625,
    }, 0);

    // header sections elements animation (not on sections as it wil interfere with sub menu positioning)
    this._scrollTl.fromTo([
        this._$hamburger,
        this._$langSwitchDesktop,
        this._$mainMenu,
        this._$mainMenuNav,
        this._$locationsWrapper,
    ], {
        y: 0,
    }, {
        y: -30,
    }, 0);

    // header deco
    this._scrollTl.fromTo(this._$deco, {
        y: 0,
    }, {
        y: -50,
    }, 0);

    // extra header deco animation if header is transparent
    if (this._transparent) {
        this._scrollTl.fromTo(this._$deco, {
            opacity: () => (this.openSlideOut ? 1 : 0),
        }, {
            opacity:  1,
            duration: 1,
            ease:       'Power0.easeNone',
        }, 0);
    }
}

function destroyTimelines () {
    if (this._scrollTl) {
        this._scrollTl.clear();
        this._scrollTl.kill();

        gsap.set([
            this.$el,
            this._$logoDesktop,
            this._$hamburger,
            this._$langSwitchDesktop,
            this._$mainMenuNav,
            this._$mainMenu,
            this._$decoShape,
        ], {
            clearProps: 'all',
        });
    }
}

function initReservation () {
    // init timelines
    this._tl.open = new gsap.timeline({
        ease:             'Power2.easeInOut',
        paused:           true,
        onCompleteParams: [this, { comleted: true }],
    });
    this._tl.close = new gsap.timeline({
        ease:             'Power2.easeInOut',
        paused:           true,
        onCompleteParams: [this, { comleted: true }],
    });

    // init tweens
    this._tl.open
        .to(this._$el, {
            backgroundColor: () => (this._isMobile ? 'rgba(0, 45, 70, 1.00)' : 'rgba(0, 45, 70, 0)'),
        }, 0)
        .to(this._$deco, {
            opacity:    1,
            duration:   0.125,
        }, 0)
        .to(this._$locationsWrapper, {
            height:   () => {
                // grab some bounding boxes to calculate the maximum hieght
                const bb = this._$locationsWrapper.getBoundingClientRect();

                if (bb.top + this.openSlideOut.$el.scrollHeight < window.innerHeight) {
                    return this.openSlideOut.$el.scrollHeight || 0;
                }
                return window.innerHeight - bb.top;
            },
            duration: 0.5,
        }, 0);

    this._tl.close
        .to(this._$deco, {
            opacity:    () => (this._transparent && this._scrollTl ? this._scrollTl.progress() : 1),
            duration:   0.25,
        }, 0.5)
        .to(this._$el, {
            backgroundColor: () => (this._isMobile ? 'rgba(0, 45, 70, 0)' : 'rgba(0, 45, 70, 0)'),
        }, 0.5)
        .to(this._$locationsWrapper, {
            height: 0,
        }, 0.5);
}

function destroyReservation () {

}

// Event handlers
function onScrollUpdate (timeline) {
    // this.log('scroll update');

    if (this._isOpen) this.open(true);
}

function onSubmenuShow () {
    this._submenuVisible = true;
}

function onSubmenuHide () {
    this._submenuVisible = false;
}

function onListOpen (e) {
    this.open();

    if (this._scrollTl) this._scrollTl.invalidate();
    this._tl.close.invalidate();

    if (e.currentTarget !== this._reservationSO && this._reservationSO.isOpen) this._reservationSO.close();
    if (e.currentTarget !== this._takeoutSO && this._takeoutSO.isOpen) this._takeoutSO.close();
    // if (e.currentTarget !== this._deliverySO && this._deliverySO.isOpen) this._deliverySO.close();
}

function onListClose (e) {
    // if (this._reservationSO.isOpen || this._deliverySO.isOpen || this._takeoutSO.isOpen) {
    if (this._reservationSO.isOpen || this._takeoutSO.isOpen) {
        this.open(true);
    }
    else {
        this.close();
        if (this._scrollTl) this._scrollTl.invalidate();
    }
}
